export enum MAIL_APP_TYPE {
  CIVIC_CENTER = 'Civic Center',
}
